import { useFormikContext } from "formik";
import { Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactElement } from "react";

type SaveReminderPrompt = {
  children: ReactElement;
};
export default function SaveReminder({ children }: SaveReminderPrompt) {
  const { dirty, isValid } = useFormikContext();
  const { t } = useTranslation();
  return (
    <Tooltip
      open={isValid && dirty}
      title={<Typography fontSize={15}>{t("buttons.save")}</Typography>}
      arrow
      placement="top"
    >
      {children}
    </Tooltip>
  );
}
